import { Builder } from '@builder.io/react';
import CarouselSection from '../../../../../../pages/home/carouselSection';


const bannerCarousal = props => {


  return (
    <div className="md:container md:mx-auto mt-0 md:mt-2- md:mb-4">
            <CarouselSection />
          </div>
  );
};

Builder.registerComponent(bannerCarousal, {
  name: 'bannerCarousal',
});
export default bannerCarousal;
